'use strict';

var React = require('react'),
    ResponsiveImageQueueMixin = require('./ResponsiveImageQueueMixin'),
    ViewportTestMixin = require('./ViewportTestMixin'),
    ImageStore = require('../stores/ImageStore'),
    UserStore = require('../stores/UserStore'),
    ImageUsageCounter = require('../molecules/ImageUsageCounter'),
    ImageAttribution = require('../molecules/ImageAttribution'),
    assign = require('react/lib/Object.assign'),
    { isMobile } = require('../utils/Browser'),
    { PropTypes } = React;

/**
 * Provides an image queue for images inside the stamp, considering window width,
 * whether lightbox is active and whether image is close to the viewport.
 * Expects `getImage` to be defined and to return a valid `ImageMedia`.
 */
var StampImageMixin = {
  mixins: [ResponsiveImageQueueMixin, ViewportTestMixin],

  propTypes: {
    lightboxState: PropTypes.oneOf(['active', 'leaving']),
    isImageInLightbox: PropTypes.func.isRequired,
    stamp: PropTypes.object.isRequired
  },

  getInitialState() {
    return assign({
      isAttributionVisible: false
    }, this.getStateFromImageStore(this.props));
  },

  getStateFromImageStore(props) {
    var stampId = props.stamp.id,
        inlineImage = this.getImage(props),
        image = ImageStore.getInStamp(inlineImage.uuid, stampId),
        sourceStamp,
        sourceImage,
        sourceUser;

    if (image) {
      sourceImage = ImageStore.getSourceImage(image);
      sourceStamp = ImageStore.getSourceStamp(image, stampId);
      sourceUser = UserStore.get(sourceStamp.user);
    }

    return { sourceImage, sourceStamp, sourceUser };
  },

  canRenderAttribution() {
    var { sourceStamp, sourceImage } = this.state,
        { stamp } = this.props;

    if (!sourceImage || !sourceStamp || !stamp) {
      return false;
    }

    var hasSourceStamp = sourceStamp.id !== stamp.id,
        hasOtherUsages = sourceImage && sourceImage.usageCount > 0;

    return hasSourceStamp || hasOtherUsages;
  },

  componentDidMount() {
    ImageStore.addChangeListener(this.handleImageStoreChange);
  },

  componentWillReceiveProps(nextProps) {
    if (this.getImage(nextProps) !== this.getImage(this.props)) {
      this.setState(this.getStateFromImageStore(nextProps));
    }
  },

  handleImageStoreChange() {
    this.setState(this.getStateFromImageStore(this.props));
  },

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.lightboxState !== this.props.lightboxState ||
        prevState.isInViewport !== this.state.isInViewport) {

      this.updateImageQueue();
    }
  },

  componentWillUnmount() {
    ImageStore.removeChangeListener(this.handleImageStoreChange);
  },

  getImageOptions() {
    var image = this.getImage(this.props);
    const devicePixelRatio = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;

    return {
      image: image,
      sizes: {
        thumb: true,
        small: this.state.imageSize > 500,
        normal: true,
        retina: devicePixelRatio > 1.5 && this.state.isInViewport,
        original: this.props.isImageInLightbox(image)
      },
      allowEmpty: this.props.allowEmpty
    };
  },

  renderUsageCounter() {
    var { sourceImage, isAttributionVisible } = this.state;
    if (!sourceImage || isAttributionVisible) {
      return;
    }

    if (sourceImage.usageCount > 0) {
      return (
        <ImageUsageCounter counter={sourceImage.usageCount} />
      );
    }
  },

  renderAttributionOnMobile() {
    if (!this.state.isAttributionVisible) {
      return;
    }

    if (!this.canRenderAttribution()) {
      return;
    }

    var { stamp } = this.props,
        { sourceStamp, sourceImage, sourceUser } = this.state;

    return (
      <ImageAttribution sourceStamp={sourceStamp}
                        sourceImage={sourceImage}
                        sourceUser={sourceUser}
                        stamp={stamp} />
    );
  },

  toggleAttributionOnMobile(e) {
    if (!isMobile()) {
      return;
    }

    e.stopPropagation();

    var isAttributionVisible = this.state.isAttributionVisible;
    this.setState({
      isAttributionVisible: !isAttributionVisible
    });
  }
};

module.exports = StampImageMixin;



/** WEBPACK FOOTER **
 ** ./mixins/StampImageMixin.js
 **/